import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/zustaendigkeiten/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="Responsibility"
      returnRoute="/auswahlfelder/responsibility"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const ResponsibilityRoute = Route;
